module.exports = __webpack_public_path__ + "static/media/cards.edf39697.svg";